import {wasKeypress} from 'was-keypress-enter';

export const toggleBodyScroll = (callback = null) => {
  if (!document) {
    return;
  }

  const scrollDisabled = document.body.classList.contains('--scroll-disabled');

  if (scrollDisabled) {
    document.body.classList.remove('--scroll-disabled');
    document.documentElement.style.maxHeight = '';
    document.documentElement.style.overflowY = '';
    if (window.__DARWIN__closeModalFunction__) {
      document.body.removeEventListener('click', window.__DARWIN__closeModalFunction__);
      document.body.removeEventListener('keydown', window.__DARWIN__closeModalFunction__);
    }

  } else {
    document.body.classList.add('--scroll-disabled');
    document.documentElement.style.maxHeight = '100vh';
    document.documentElement.style.overflowY = 'hidden';
    window.__DARWIN__closeModalFunction__ = closeModalAndRestoreScrollOnOutsideClick(callback);
    document.body.addEventListener('click', window.__DARWIN__closeModalFunction__);
    document.body.addEventListener('keydown', window.__DARWIN__closeModalFunction__);
  }
};
export default toggleBodyScroll;

const closeModalAndRestoreScrollOnOutsideClick = callback => e => {
  if (wasKeypress(e, 27)) {
    callback();
    return;
  }

  if (!e.target.classList.contains('modal__overlay')) {
    return;
  }

  callback();
};
